<template>
    <div class="content">
        <ul :class="['product', isBasic ? '' : 'product-combo']" v-for="item in list" :key="item.name">
            <template v-if="item.name === '产品内容' || item.name === '套餐内容'">
                <li style="font-weight: Bold;color: #313238; margin-bottom: 9px;">{{item.name}}</li>
                <li v-for="(product, index) in item.children" :key="index">
                    <img style="width: 16px; height: 16px; margin-right: 8px; margin-top: 4px" :src="product.resource" alt="">
                    <span>{{product.name}}</span>
                    <span v-if="product.extra_info && product.extra_info.new" class="new">new</span>
                </li>
                <!-- <li>更多详细日志</li> -->
            </template>
            <template v-if="item.name === '适用场景'">
                <li style="font-weight: Bold;color: #313238;">适用场景</li>
                <li class="item" v-for="(product, index) in item.extra_info.scene" :key="index">
                    <img style="width: 14px; height: 14px; margin-top: 6px; margin-right: 4px;" src="../../images/downloads/icon-success.svg" alt="">
                    <span>{{product}}</span>
                </li>
            </template>
            <template v-if="item.name === '更新内容'">
            </template>
            <template v-if="item.name === '推荐部署所需资源和配置'">
                <li style="font-weight: Bold;color: #313238; margin-bottom: 9px;">推荐部署所需资源和配置</li>
                <li class="item">
                    <span>体验环境：</span>
                    <span class="config">{{config.experience_env}}</span>
                    <span class=""> * {{config.experience_num}}</span>
                </li>
                <li class="item">
                    <span>生产环境：</span>
                    <span class="config">{{config.prod_env}}</span>
                    <span class=""> * {{config.prod_num}}</span>
                </li>
                <li v-if="config.ps" class="ps">
                    <span>Ps：</span>
                    <span class="">{{config.ps}}</span>
                </li>
            </template>
            <template v-if="!isBasic && item.name === '前往部署'">
                <div class="combo-deploy" @click="jumpPage(item)">前往部署</div>
            </template>
            <template v-if="!isBasic && item.name === '立即下载'">
                <div class="combo-download" @click="jumpPage(item, 'download')">立即下载</div>
            </template>
            <template v-if="!isBasic && item.name === '安装指引'">
                <div class="combo-install" @click="jumpPage(item)">安装指引</div>
            </template>
        </ul>
    </div>
</template>

<script>

export default {
    name: 'content',
    props: {
        list: Array,
        comboType: Boolean,
        isBasic: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            scene: [
                "【全平台】支持国际化",
                "【PaaS】全新设计的用户界面，给您更友好的体验",
                "【全平台】支持国际化",
                "【管控平台】新增支持管控arm、aix（仅支持任务执行和文件分发）机器",
                "【作业平台】支持高危语句拦截能力，并支持查看“扫描”和“拦截”记录",
            ],
            config: []
        }
    },
    computed: {
        isLogin () {
            return this.$store.state.isLogin
        }
    },
    watch: {
        list: {
            handler (val) {
                this.setConfigValue(val)
            },
            // immediate: true,
            deep: true
        }
    },
    mounted () {
        this.setConfigValue(this.list)
    },
    methods: {
        recordUserDownload(cur) {
            this.$emit('recordUserDownload', cur)
        },
        setConfigValue (list) {
            this.config = []
            if (list) {
                const cur = list.find(item => item.name === '推荐部署所需资源和配置')
                if (cur && 'experience_env' in cur.extra_info) {
                    const { experience_env, ps, prod_env } = cur.extra_info
                    const config = {
                        experience_env: experience_env.config.split('-')[0],
                        experience_num: experience_env.config.split('-')[1],
                        prod_env: prod_env.config.split('-')[0],
                        prod_num: prod_env.config.split('-')[1],
                        ps,
                    }
                    this.config = config
                }
            }
        },
        jumpPage (cur, type) {
            if (type && type === 'download') {
                this.$emit('recordUserDownload', cur)
                return
            }
            if (cur) {
                this.$emit('containerDeployValidate', cur)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    width: 100%;
    height: 100%;
    .product {
        float: left;
        min-width: 220px;
        max-width: 460px;
        height: 100%;
        // padding-right: 60px;
        margin-right: 20px;
        font-size: 12px;
        li {
            margin: 4px 0;
            line-height: 26px;
            display: flex;
            .new {
                width: 30px;
                height: 16px;
                line-height: 12px;
                padding: 2px;
                background: #E4FAF0;
                border-radius: 2px;
                color: #0fa669;
                margin-top: 6px;
                font-weight: bold;
            }
            .config {
                border-radius: 12px;
                height: 20px;
                padding: 0px 4px;
                background-color: #f0f1f5;
                line-height: 20px;
                margin-top: 4px;
                vertical-align: middle;
            }
        }
        .ps {
            font-size: 12px;
            color: #979BA5;
            align-items: unset;
        }
    }
    .product-combo {
        margin-top: 32px;
    }
    .combo-deploy {
        text-align: center;
        width: 260px;
        height: 32px;
        font-size: 12px;
        background: #3A84FF;
        border: 1px solid #3A84FF;
        border-radius: 2px;
        color: #fff;
        line-height: 32px;
        cursor: pointer;
        margin: 20px 34px 20px 34px;
        &:hover {
            opacity: 0.7;
        }
    }
    .combo-download {
        width: 260px;
        height: 32px;
        background: #3A84FF;
        border-radius: 3px;
        text-align: center;
        line-height: 32px;
        color: #fff;
        font-size: 12px;
        margin: 20px 34px 12px 34px;
        cursor: pointer;
        &:hover {
            color: #1768EF;
        }
    }
    .combo-install {
        width: 260px;
        height: 32px;
        text-align: center;
        font-size: 12px;
        line-height: 32px;
        color: #3A84FF;
        font-size: 12px;
        margin: 0px 34px 12px 34px;
        cursor: pointer;
        &:hover {
            color: #1768EF;
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// content.vue?bf57cd92